export default __webpack_public_path__ + "static/media/edited-3-mobile.24721c09.jpg";